import { http } from './../../../libs/util'
import util from '../../../libs/util'

const { 
    budget_order_create, 
    budget_order_list,
    budget_order_update, 
    budget_order_detail,
    budget_order_create_sub_order,
    budget_order_sub_order_detail,
    budget_order_update_sub_order,
    budget_order_delete_sub_order,
    budget_order_mine_list,
    budget_order_full_detail,
    budget_order_delete,
    budget_order_change_important,
    budget_amount_quarter_amount,
 } = util.api || {}

// 新增预算申请
export function budgetOrderCreateApi(params) {
    return http.post(budget_order_create, params)
}

// 编辑预算申请
export function budgetOrderUpdateApi(params) {
    return http.post(budget_order_update, params)
}

// 预算申请列表
export function getBudgetOrderListApi(params) {
    return http.get(budget_order_list, params)
}
// 我的预算申请列表
export function getBudgetOrderListAboutMeApi(params) {
    return http.get(budget_order_mine_list, params)
}

// 预算申请详情 from 财务
export function getbudgetOrderDetailFromFinApi(params) {
    return http.get(budget_order_full_detail, params)
}
// 预算申请详情 from 业务处理
export function getbudgetOrderDetailFromBusinessApi(params) {
    return http.get(budget_order_detail, params)
}

// 预算申请单子单详情
export function budgetOrderSubOrderDetailApi(params) {
    return http.get(budget_order_sub_order_detail, params)
}
// 新增预算申请单子单
export function budgetOrderCreateSubOrderApi(params) {
    return http.post(budget_order_create_sub_order, params)
}
// 编辑预算申请单
export function budgetOrderUpdateSubOrderApi(params) {
    return http.post(budget_order_update_sub_order, params)
}

// 删除预算申请子单
export function budgetOrderDeleteSubOrderApi(params) {
    return http.post(budget_order_delete_sub_order, params)
}

// 删除预算母单
export function budgetOrderDeleteApi(params) {
    return http.post(budget_order_delete, params)
}

// 设置单据为重要或者取消重要单据
export function budgetOrderChangeImportantApi(params) {
    return http.post(budget_order_change_important, params)
}
// 获取预算月份分配
// budget_amount_quarter_amount
export function budgetAmountQuarterAmountApi(params) {
    return http.get(budget_amount_quarter_amount, params)
}